module.exports = __webpack_public_path__ + "img/half-circle.39f124ea.svg";